module.exports = __webpack_public_path__ + "img/logo-1.c169b2d5.png";